<template>
<div class="chapter">
<div class="inner_page">
<div id="outpfm1">
<div class="generated-style"></div>
<div class="generated-style">
<p class="cImage" xml:lang="en-us"><span class="generated-style"><img alt="Outlaws with Badges display type.tif" class="generated-style" src="Images/OutlawswithBadgesdi_fmt.jpeg"/></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?2e9824de